/**
 * Печать модели в новом заказе.
 *
 * Большинство работ приходит СКАНОМ, а скан заканчивается печатью модели:
 * в журнале лаборатории доп «Печать 3D модели» стоит почти в каждом втором
 * заказе. Распознать, скан пришёл или гипс, программа не может, поэтому новый
 * заказ открывается с печатью модели ×1 — убрать её для гипса быстрее, чем
 * добавлять в каждый второй заказ.
 *
 * Исключение — когда печать модели и есть сама работа: в каталоге для этого
 * есть базовые позиции «Печать 3D модели» и «Печать 3D модели для гипсовки».
 * Доп поверх такой основы означал бы двойную печать и двойную цену.
 */
export const MODEL_PRINT_NAME = 'Печать 3D модели';
const норм = (text) => text.trim().replace(/\s+/g, ' ').toLowerCase();
/** Доп «Печать 3D модели» из справочника; `null`, если его там нет. */
export function modelPrintExtraId(constructions) {
    const item = constructions.find((k) => k.type === 'Дополнительный элемент' && норм(k.name) === норм(MODEL_PRINT_NAME));
    return item?.id ?? null;
}
/** Основная конструкция — сама печать модели (в том числе «для гипсовки»). */
export function isModelPrintBase(construction) {
    return (construction?.type === 'Базовая конструкция' && норм(construction.name).startsWith(норм(MODEL_PRINT_NAME)));
}
//# sourceMappingURL=model-print.js.map